import { useState } from 'react';
import { supabase } from '../utils/supabase';
import { Mail, Lock, LogIn, UserPlus } from 'lucide-react';
import './Auth.css';

export default function Auth() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);

  const handleOAuth = async (provider: 'google' | 'github') => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider,
        options: {
          redirectTo: window.location.origin
        }
      });
      if (error) throw error;
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || '소셜 로그인 중 오류가 발생했습니다.' });
    }
  };

  const handleAuth = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      if (isSignUp) {
        const { error } = await supabase.auth.signUp({
          email,
          password,
        });
        if (error) throw error;
        setMessage({ type: 'success', text: '가입 확인 이메일을 확인해주세요!' });
      } else {
        const { error } = await supabase.auth.signInWithPassword({
          email,
          password,
        });
        if (error) throw error;
      }
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || '인증 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>{isSignUp ? '회원가입' : '로그인'}</h2>
          <p>{isSignUp ? '새로운 계정을 생성합니다.' : '계정에 로그인하여 시작하세요.'}</p>
        </div>

        <div className="oauth-buttons">
          <button onClick={() => handleOAuth('google')} className="oauth-btn google">
            <img src="https://www.google.com/favicon.ico" alt="Google" />
            Google로 시작하기
          </button>
        </div>

        <div className="divider">
          <span>또는 이메일로 {isSignUp ? '가입' : '로그인'}</span>
        </div>

        <form onSubmit={handleAuth} className="auth-form">
          <div className="input-field">
            <Mail className="input-icon" size={20} />
            <input
              type="email"
              placeholder="이메일 주소"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-field">
            <Lock className="input-icon" size={20} />
            <input
              type="password"
              placeholder="비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {message && (
            <div className={`message ${message.type}`}>
              {message.text}
            </div>
          )}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? (
              '처리 중...'
            ) : isSignUp ? (
              <>
                <UserPlus size={18} /> 회원가입
              </>
            ) : (
              <>
                <LogIn size={18} /> 로그인
              </>
            )}
          </button>
        </form>

        <div className="auth-footer">
          <button 
            className="toggle-btn"
            onClick={() => {
              setIsSignUp(!isSignUp);
              setMessage(null);
            }}
          >
            {isSignUp ? '이미 계정이 있으신가요? 로그인' : '계정이 없으신가요? 회원가입'}
          </button>
        </div>
      </div>
    </div>
  );
}